const STATUS = {
  published: { label: "Pubblicata", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  draft: { label: "Bozza", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  disabled: { label: "Disattivata", cls: "bg-zinc-100 text-zinc-600 border-zinc-200" },
  archived: { label: "Archiviata", cls: "bg-zinc-50 text-zinc-400 border-zinc-200" },
  active: { label: "Attivo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.draft;
  const label = status === "archived" && testId?.startsWith("client") ? "Archiviato" : s.label;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
};

export const PageHeader = ({ eyebrow, title, children, description }) => (
  <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up">
    <div>
      {eyebrow && <div className="eyebrow mb-2">{eyebrow}</div>}
      <h1 className="font-display text-4xl sm:text-5xl leading-[1.05]" data-testid="page-title">{title}</h1>
      {description && <p className="mt-3 max-w-xl text-sm text-zinc-500">{description}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Stat = ({ label, value, hint, testId }) => (
  <div className="panel p-5">
    <div className="eyebrow">{label}</div>
    <div className="mt-3 font-display text-4xl" data-testid={testId}>{value}</div>
    {hint && <div className="mt-1 text-xs text-zinc-500">{hint}</div>}
  </div>
);

export const Empty = ({ title, children }) => (
  <div className="panel flex flex-col items-center justify-center px-6 py-16 text-center">
    <div className="font-display text-2xl">{title}</div>
    <div className="mt-2 max-w-sm text-sm text-zinc-500">{children}</div>
  </div>
);
